import { render, staticRenderFns } from "./userTitle.vue?vue&type=template&id=4f23eba0"
import script from "./userTitle.vue?vue&type=script&lang=js"
export * from "./userTitle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports